import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { UserStatus } from '../../../../types/UserStatus';
import { queries } from '../../../common/api/queryKeys/queries';

interface ManagementUsersListParams {
    searchQuery?: string;
    companyIds?: string[];
    groupIds?: string[];
    statuses?: UserStatus[];
}

export const useManagementUsersList = (params: ManagementUsersListParams) => {
    return useQuery({
        ...queries.members.list(params),
        placeholderData: keepPreviousData,
        select: (data) => {
            return data.content;
        },
    });
};
